<template>
  <create-account-layout
    :current-step="2"
    title="Company Details"
  >
    <div v-if="currentStep === CompanyDetailsStep.Company">
      <section>
        <p class="mb-6 mt-8 text-left text-sm text-dark-gray">
          Let’s get some basic information about your company.
        </p>
        <!-- ************************************************************************************* -->
        <!-- Resources country codes: https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes -->
        <!-- Should be ISO_3166 Alpha-2 code -->
        <!-- ************************************************************************************* -->

        <!-- <div>
        <places-auto-complete 
          id="physical_address"
          label="PHYSICAL ADDRESS"
          @placechanged="onPhysicalAddressChange"
          @placecleared="onClearPhysical"
          placeholder="Enter Address"
          :countries="['CA', 'US', 'MX']"
          :types="'street_address'"
        />
      </div>
      <div class="mt-6">
        <places-auto-complete 
          id="mailing_address"
          label="MAILING ADDRESS"
          @placechanged="onMailingAddressChange"
          @placecleared="onClearMailing"
          placeholder="Enter Address"
          :countries="['US', 'CA', 'MX']"
          :types="'street_address'"
        />
      </div>  -->
        <template
          v-if="isACanadianCarrier || isAMexicanCarrier || isAEuropeanCarrier"
        >
          <div>
            <p
              class="mb-4 border-b border-light-gray text-left text-gray-over-dark"
            >
              Physical Address
            </p>
            <form-field
              id="street1-physical"
              label="Address line 1"
              :value="valueObject.physical.street1"
              placeholder=""
              :on-input="onCanadianMexicanOrEuropeanAddress"
              name="street1"
              :custom-padding="true"
            />
            <form-field
              id="street2-physical"
              label="Address line 2"
              :value="valueObject.physical.street2"
              placeholder=""
              :on-input="onCanadianMexicanOrEuropeanAddress"
              name="street2"
              :custom-padding="true"
            />
            <div
              class="flex gap-2"
              style="margin-top: -10px"
            >
              <form-field
                id="city-physical"
                label="City"
                :value="valueObject.physical.city"
                placeholder=""
                :on-input="onCanadianMexicanOrEuropeanAddress"
                name="city"
                :custom-padding="true"
              />
              <div
                class="w-full"
                style="margin-top: 10px"
              >
                <label
                  class="mb-1 block text-left text-2xs font-bold uppercase text-dark-gray"
                  style="margin-top: 2px"
                  >{{
                    isACanadianCarrier || isAEuropeanCarrier
                      ? 'Province/Territory'
                      : 'State'
                  }}</label
                >
                <div>
                  <dropdown
                    v-if="isACanadianCarrier || isAMexicanCarrier"
                    :options="
                      isACanadianCarrier ? canadianStates : mexPlaceholdersState
                    "
                    :default="''"
                    name="states"
                    placeholder=""
                    :exclude-selected="true"
                    class="text-xs"
                    :custom-style="{ height: '42px' }"
                    @dropdown-input="onTypeSelectedPhysical"
                  />
                  <form-field
                    v-else
                    id="state-physical"
                    :value="valueObject.mailing.state"
                    placeholder=""
                    :on-input="onCanadianMexicanOrEuropeanAddress"
                    name="state"
                    :custom-padding="true"
                    :remove-y-margin="true"
                    :allow-full-state-name="true"
                  />
                </div>
              </div>
            </div>
            <div style="margin-top: -10px">
              <form-field
                id="postal-code-physical"
                label="Postal Code"
                :value="valueObject.physical.postal_code"
                placeholder=""
                :on-input="onCanadianMexicanOrEuropeanAddress"
                name="postal_code"
                :custom-padding="true"
              />
            </div>
          </div>
          <div class="mt-8">
            <p
              class="mb-4 border-b border-light-gray text-left text-gray-over-dark"
            >
              Mailing Address
            </p>
            <section>
              <check-box
                :active="sameAddressChecked"
                :handle-select="onSameAddressCheck"
                :item="'Use physical address'"
              />
            </section>
            <template v-if="!sameAddressChecked">
              <form-field
                id="street1-mailing"
                label="Address line 1"
                :value="valueObject.mailing.street1"
                placeholder=""
                :on-input="onCanadianMexicanOrEuropeanAddress"
                name="street1"
                :custom-padding="true"
              />
              <form-field
                id="street2-mailing"
                label="Address line 2"
                :value="valueObject.mailing.street2"
                placeholder=""
                :on-input="onCanadianMexicanOrEuropeanAddress"
                name="street2"
                :custom-padding="true"
              />
              <div
                class="flex gap-2"
                style="margin-top: -10px"
              >
                <form-field
                  id="city-mailing"
                  label="City"
                  :value="valueObject.mailing.city"
                  placeholder=""
                  :on-input="onCanadianMexicanOrEuropeanAddress"
                  name="city"
                  :custom-padding="true"
                />
                <div
                  class="w-full"
                  style="margin-top: 10px"
                >
                  <label
                    class="mb-1 block text-left text-2xs font-bold uppercase text-dark-gray"
                    style="margin-top: 2px"
                    >{{
                      isACanadianCarrier || isAEuropeanCarrier
                        ? 'Province/Territory'
                        : 'State'
                    }}</label
                  >
                  <div>
                    <dropdown
                      v-if="isACanadianCarrier || isAMexicanCarrier"
                      :options="
                        isACanadianCarrier
                          ? canadianStates
                          : mexPlaceholdersState
                      "
                      :default="''"
                      name="states"
                      placeholder=""
                      :exclude-selected="true"
                      class="text-xs"
                      :custom-style="{ height: '42px' }"
                      @dropdown-input="onTypeSelectedMailing"
                    />
                    <form-field
                      v-else
                      id="state-mailing"
                      :value="valueObject.mailing.state"
                      placeholder=""
                      :on-input="onCanadianMexicanOrEuropeanAddress"
                      name="state"
                      :custom-padding="true"
                      :remove-y-margin="true"
                      :allow-full-state-name="true"
                    />
                  </div>
                </div>
              </div>
              <div style="margin-top: -10px">
                <form-field
                  id="postal-code-mailing"
                  label="Postal Code"
                  :value="valueObject.mailing.postal_code"
                  placeholder=""
                  :on-input="onCanadianMexicanOrEuropeanAddress"
                  name="postal_code"
                  :custom-padding="true"
                />
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div>
            <places-input
              label="PHYSICAL ADDRESS"
              @placechanged="onPhysicalAddressChange"
            />
          </div>
          <div class="mb-4 mt-6">
            <places-input
              label="MAILING ADDRESS"
              @placechanged="onMailingAddressChange"
            />
          </div>
        </template>
      </section>
      <button-main
        class="my-3 mb-4"
        :disabled="!isContinueEnabled()"
        value="Continue"
        @click="handleContinue"
      >
        Continue
      </button-main>
    </div>
    <div v-else-if="currentStep === CompanyDetailsStep.Certificate">
      <section>
        <p class="mb-6 mt-8 text-left text-sm text-dark-gray">
          Upload your certificate of authority.
        </p>
        <p class="mt-8 text-left text-sm text-body-color">
          Please upload a photo or document.
        </p>
        <div class="mb-4 mt-6">
          <file-selector-grid
            v-model="files"
            accept="image/*,.pdf"
          />
        </div>
      </section>
      <button-main
        class="my-3 mb-4"
        :disabled="!isSaveAndContinueEnabled()"
        :is-loading="isLoading"
        value="Continue"
        @click="onSaveAndContine()"
      >
        Save & Continue
      </button-main>
    </div>
  </create-account-layout>
  <confirm-upload-certificate-modal
    :visible="confirmationModal"
    @close="confirmationModal = false"
    @authorize="handleSaveAndContinue"
  />
</template>

<script>
var places_service = null;

const ADDRESS_COMPONENTS = {
  subpremise: 'short_name',
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  administrative_area_level_2: 'long_name',
  country: 'long_name',
  postal_code: 'short_name',
};

import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import ButtonMain from '@/components/Button.vue';
import FileSelectorGrid from '@/components/FileSelectorGrid.vue';
// import PlacesAutoComplete from "@/components/PlacesAutoComplete.vue";
import { toastResponse } from '@/common/handleServerResponse';
import PlacesInput from '@/components/PlacesInput.vue';
import ConfirmUploadCertificateModal from '@/components/modals/ConfirmUploadCertificateModal.vue';
import FormField from '@/components/FormField.vue';
import Dropdown from '@/components/Dropdown.vue';
import CheckboxRounded from '@/components/CheckboxRounded.vue';

const CompanyDetailsStep = {
  Company: 0,
  Certificate: 1,
};

export default {
  name: 'CompanyDetails',
  components: {
    CreateAccountLayout,
    ButtonMain,
    // PlacesAutoComplete,
    FileSelectorGrid,
    PlacesInput,
    ConfirmUploadCertificateModal,
    FormField,
    Dropdown,
    'check-box': CheckboxRounded,
  },
  data: function () {
    return {
      physicalAddress: undefined,
      mailingAddress: undefined,
      isLoading: false,
      isUploading: false,
      CompanyDetailsStep,
      selectedTab: 'physical',
      sameAddressChecked: false,
      currentStep: CompanyDetailsStep.Company,
      isUploaded: true,
      files: [],
      confirmationModal: false,
      canadianAddress: {
        physical: {
          street1: '',
          street2: '',
          city: '',
          state: '',
          postal_code: '',
          nationality: 'CA',
        },
        mailing: {
          street1: '',
          street2: '',
          city: '',
          state: '',
          postal_code: '',
          nationality: 'CA',
        },
      },
      mexicanAddress: {
        physical: {
          street1: '',
          street2: '',
          city: '',
          state: '',
          postal_code: '',
          nationality: 'MX',
        },
        mailing: {
          street1: '',
          street2: '',
          city: '',
          state: '',
          postal_code: '',
          nationality: 'MX',
        },
      },
      europeanAddress: {
        physical: {
          street1: '',
          street2: '',
          city: '',
          state: '',
          postal_code: '',
          nationality: '',
        },
        mailing: {
          street1: '',
          street2: '',
          city: '',
          state: '',
          postal_code: '',
          nationality: '',
        },
      },
      canadianStates: [
        { label: 'Alberta', id: 'AB' },
        { label: 'British Columbia', id: 'BC' },
        { label: 'Manitoba', id: 'MB' },
        { label: 'New Brunswick', id: 'NB' },
        { label: 'Newfoundland and Labrador', id: 'NL' },
        { label: 'Nova Scotia', id: 'NS' },
        { label: 'Ontario', id: 'ON' },
        { label: 'Prince Edward Island', id: 'PE' },
        { label: 'Quebec', id: 'QC' },
        { label: 'Saskatchewan', id: 'SK' },
        { label: 'Northwest Territories', id: 'NT' },
        { label: 'Nunavut', id: 'NU' },
        { label: 'Yukon', id: 'YT' },
      ],
      mexStates: [
        { key: 'Ags.', value: 'AG' },
        { key: 'B.C.', value: 'BC' },
        { key: 'B.C.S', value: 'BS' },
        { key: 'Camp.', value: 'CM' },
        { key: 'Chis.', value: 'CS' },
        { key: 'Chih.', value: 'CH' },
        { key: 'Coah.', value: 'CO' },
        { key: 'Col.', value: 'CL' },
        { key: 'CDMX', value: 'DF' },
        { key: 'Dgo.', value: 'DG' },
        { key: 'Gto.', value: 'GT' },
        { key: 'Gro.', value: 'GR' },
        { key: 'Hgo.', value: 'HG' },
        { key: 'Jal.', value: 'JA' },
        { key: 'Edomex.', value: 'EM' },
        { key: 'Méx.', value: 'EM' },
        { key: 'Mich.', value: 'MI' },
        { key: 'Mor.', value: 'MO' },
        { key: 'Nay.', value: 'NA' },
        { key: 'N.L.', value: 'NL' },
        { key: 'Oax.', value: 'OA' },
        { key: 'Pue.', value: 'PU' },
        { key: 'Qro.', value: 'QT' },
        { key: 'Roo.', value: 'QR' },
        { key: 'Q. Roo.', value: 'QR' },
        { key: 'Q.R.', value: 'QR' },
        { key: 'S.L.P', value: 'SL' },
        { key: 'Sin.', value: 'SI' },
        { key: 'Son.', value: 'SO' },
        { key: 'Tab.', value: 'TB' },
        { key: 'Tamps.', value: 'TM' },
        { key: 'Tlax.', value: 'TL' },
        { key: 'Ver.', value: 'VE' },
        { key: 'Yuc.', value: 'YU' },
        { key: 'Zac.', value: 'ZA' },
      ],
      mexPlaceholdersState: [
        { label: 'Aguascalientes', id: 'AG' },
        { label: 'Baja California', id: 'BC' },
        { label: 'Baja California Sur', id: 'BS' },
        { label: 'Campeche', id: 'CM' },
        { label: 'Chiapas', id: 'CS' },
        { label: 'Chihuahua', id: 'CH' },
        { label: 'Coahuila', id: 'CO' },
        { label: 'Colima', id: 'CL' },
        { label: 'Ciudad de México', id: 'DF' },
        { label: 'Durango', id: 'DG' },
        { label: 'Guanajuato', id: 'GT' },
        { label: 'Guerrero', id: 'GR' },
        { label: 'Hidalgo', id: 'HG' },
        { label: 'Jalisco', id: 'JA' },
        { label: 'Estado de México', id: 'EM' },
        { label: 'Michoacán', id: 'MI' },
        { label: 'Morelos', id: 'MO' },
        { label: 'Nayarit', id: 'NA' },
        { label: 'Nuevo León', id: 'NL' },
        { label: 'Oaxaca', id: 'OA' },
        { label: 'Puebla', id: 'PU' },
        { label: 'Querétaro', id: 'QT' },
        { label: 'Quintana Roo', id: 'QR' },
        { label: 'San Luis Potosí', id: 'SL' },
        { label: 'Sinaloa', id: 'SI' },
        { label: 'Sonora', id: 'SO' },
        { label: 'Tabasco', id: 'TB' },
        { label: 'Tamaulipas', id: 'TM' },
        { label: 'Tlaxcala', id: 'TL' },
        { label: 'Veracruz', id: 'VE' },
        { label: 'Yucatán', id: 'YU' },
        { label: 'Zacatecas', id: 'ZA' },
      ],
    };
  },
  computed: {
    tabOptions() {
      return [
        {
          title: 'Physical Address',
        },
        {
          title: 'Mailing Address',
        },
      ];
    },
    valueObject() {
      if (this.isACanadianCarrier) {
        return this.canadianAddress;
      }
      if (this.isAEuropeanCarrier) {
        return this.europeanAddress;
      }
      return this.mexicanAddress;
    },
    isACanadianCarrier() {
      const CanadianIdentifier = localStorage?.getItem('identifier');
      return (
        this.intraCanadianIdentifiers.includes(CanadianIdentifier) || false
      );
    },
    isAMexicanCarrier() {
      return localStorage?.getItem('identifier-mx') || false;
    },
    isAEuropeanCarrier() {
      return localStorage?.getItem('identifier-eu') || false;
    },
    intraCanadianIdentifiers() {
      return [
        'CVOR_ON',
        'NIR_QC',
        'NSC_AB',
        'NSC_BC',
        'NSC_MB',
        'NSC_NB',
        'NSC_NF',
        'NSC_NT',
        'NSC_NS',
        'NSC_NU',
        'NSC_PE',
        'NSC_SK',
        'NSC_YT',
      ];
    },
    preferredCountry() {
      return this.$store.state.users.preferredCountry?.toUpperCase() || '';
    },
  },
  created: async function () {
    const initMap = setInterval(function () {
      // eslint-disable-next-line no-undef
      let alreadyLoaded = google?.maps?.places;
      if (alreadyLoaded) {
        // eslint-disable-next-line no-undef
        places_service = new google.maps.places.PlacesService(
          document.createElement('div')
        );
        clearInterval(initMap);
      }
    }, 50);

    const carrierId = this.$store.state.carriers.carrierDetails.id;
    if (carrierId) {
      const claimedRes = await this.$store.dispatch(
        'users/hasCarrierBeenClaimed',
        carrierId
      );
      if ([201, 200].includes(claimedRes.status)) {
        this.$store.commit('carriers/setMaskedContacts', claimedRes.data);
        this.$router.push({
          name: 'RequestAccess',
          params: { carrierHasBeenClaimed: true },
        });
        return;
      }
      // 404 means carrier not claimed
      if (![404].includes(claimedRes.status)) {
        // unkown error
        toastResponse(this, claimedRes, null);
      }
    }
    this.isLoading = false;
  },
  mounted() {
    if (this.preferredCountry?.length > 0) {
      this.europeanAddress['physical']['nationality'] = this.preferredCountry;
      this.europeanAddress['mailing']['nationality'] = this.preferredCountry;
    }
  },
  methods: {
    onSameAddressCheck: function () {
      this.sameAddressChecked = !this.sameAddressChecked;
    },
    onTypeSelectedPhysical: function (type) {
      this.valueObject.physical.state = type?.id;
    },
    onTypeSelectedMailing: function (type) {
      this.valueObject.mailing.state = type?.id;
    },
    onCanadianMexicanOrEuropeanAddress(event) {
      const isPhysical = event.target.id.includes('physical') || false;
      const selectedType = isPhysical ? 'physical' : 'mailing';
      if (this.isACanadianCarrier) {
        this.canadianAddress[selectedType][event.target.name] =
          event.target.value;
      }
      if (this.isAMexicanCarrier) {
        this.mexicanAddress[selectedType][event.target.name] =
          event.target.value;
      }
      if (this.isAEuropeanCarrier) {
        this.europeanAddress[selectedType][event.target.name] =
          event.target.value;
      }
    },
    onSaveAndContine() {
      this.confirmationModal = true;

      const CanadianIdentifier = localStorage?.getItem('identifier');

      if (CanadianIdentifier) {
        const showConfirmationModal =
          this.intraCanadianIdentifiers.includes(CanadianIdentifier);

        if (showConfirmationModal) {
          this.visible = true;
          return;
        }
      }

      this.handleSaveAndContinue();
    },
    formatResult(place) {
      let returnData = {};
      for (let i = 0; i < place.address_components.length; i++) {
        let addressType = place.address_components[i].types[0];

        if (ADDRESS_COMPONENTS[addressType]) {
          let val =
            place.address_components[i][ADDRESS_COMPONENTS[addressType]];
          returnData[addressType] = val;
        }
      }

      returnData['latitude'] = place.geometry.location.lat();
      returnData['longitude'] = place.geometry.location.lng();
      return returnData;
    },

    async getByPlaceIdInfoAddress(placeId, type) {
      places_service.getDetails({ placeId: placeId }, (place, status) => {
        if (status === 'OK') {
          if (type === 'mailing') {
            this.mailingAddress = this.formatResult(place);
          }
          if (type === 'physical') {
            this.physicalAddress = this.formatResult(place);
          }
        }
      });
    },
    onClearPhysical: function () {
      this.physicalAddress = undefined;
    },
    onClearMailing: function () {
      this.mailingAddress = undefined;
    },
    onPhysicalAddressChange: function (e) {
      if (!e) {
        this.physicalAddress = e;
      } else {
        this.getByPlaceIdInfoAddress(e, 'physical');
      }
    },
    onMailingAddressChange: function (e) {
      if (!e) {
        this.mailingAddress = e;
      } else {
        this.getByPlaceIdInfoAddress(e, 'mailing');
      }
    },
    isUploadEnabled: function () {
      return this.files.length > 0;
    },
    handleUpload: function () {
      this.isUploaded = true;
    },
    isContinueEnabled: function () {
      const isAddressComplete = (address) =>
        address.street1 && address.city && address.state && address.postal_code;

      if (
        this.isACanadianCarrier ||
        this.isAMexicanCarrier ||
        this.isAEuropeanCarrier
      ) {
        if (this.sameAddressChecked) {
          return isAddressComplete(this.valueObject.physical);
        }
        return (
          isAddressComplete(this.valueObject.physical) &&
          isAddressComplete(this.valueObject.mailing)
        );
      }

      return this.physicalAddress && this.mailingAddress;
    },
    isSaveAndContinueEnabled: function () {
      const isAddressComplete = (address) =>
        address.street1 && address.city && address.state && address.postal_code;

      if (
        this.isACanadianCarrier ||
        this.isAMexicanCarrier ||
        this.isAEuropeanCarrier
      ) {
        if (this.sameAddressChecked) {
          return (
            isAddressComplete(this.valueObject.physical) &&
            this.isUploadEnabled()
          );
        }
        return (
          isAddressComplete(this.valueObject.physical) &&
          isAddressComplete(this.valueObject.mailing) &&
          this.isUploadEnabled()
        );
      }

      return (
        this.physicalAddress && this.mailingAddress && this.isUploadEnabled()
      );
    },
    handleContinue: async function () {
      if (!this.isContinueEnabled()) {
        return;
      }
      this.currentStep = CompanyDetailsStep.Certificate;
    },
    getCountryAbbreviation(country) {
      switch (country) {
        case 'Canada':
          return 'CA';
        case 'United States':
          return 'US';
        case 'Mexico':
          return 'MX';
        default:
          return country;
      }
    },
    getStateAbbreviation(state) {
      if (state.length > 2) {
        const code = this.mexStates.filter(
          (mexState) => mexState.key.toLowerCase() === state.toLowerCase()
        )[0]?.value;
        return code;
      }
      return state;
    },
    getAddressFromPlace(place) {
      return {
        street1: place.street_number + ' ' + place.route,
        street2: place.administrative_area_level_2,
        city: place.locality,
        state: this.getStateAbbreviation(place.administrative_area_level_1),
        postal_code: place.postal_code,
        nationality: this.getCountryAbbreviation(place.country),
      };
    },
    async handleSaveAndContinue() {
      if (!this.isContinueEnabled() || this.isSaving) {
        return;
      }
      this.confirmationModal = false;
      this.isLoading = true;

      let physical_address;
      let mailing_address;

      if (this.isACanadianCarrier) {
        physical_address = this.canadianAddress.physical;
        mailing_address = this.sameAddressChecked
          ? this.canadianAddress.physical
          : this.canadianAddress.mailing;
      } else if (this.isAMexicanCarrier) {
        physical_address = this.mexicanAddress.physical;
        mailing_address = this.sameAddressChecked
          ? this.mexicanAddress.physical
          : this.mexicanAddress.mailing;
      } else if (this.isAEuropeanCarrier) {
        physical_address = this.europeanAddress.physical;
        mailing_address = this.sameAddressChecked
          ? this.europeanAddress.physical
          : this.europeanAddress.mailing;
      } else {
        physical_address = this.getAddressFromPlace(this.physicalAddress);
        mailing_address = this.getAddressFromPlace(this.mailingAddress);
      }

      const body = {
        identifier: {
          certificate: this.files[0],
        },
        physical_address: physical_address,
        mailing_address: mailing_address,
      };

      this.isSaving = true;

      const res = await this.$store.dispatch(
        'carriers/claimManualCarrier',
        body
      );
      this.isSaving = false;
      if (![201, 200].includes(res.status)) {
        toastResponse(this, res, null);
        if (res.status === 422) {
          // what to do if carrier is claimed
          const carrierId = this.$store.state.carriers.carrierDetails.id;
          const claimedRes = await this.$store.dispatch(
            'users/hasCarrierBeenClaimed',
            carrierId
          );
          if ([201, 200].includes(claimedRes.status)) {
            this.$store.commit('carriers/setMaskedContacts', claimedRes.data);
            this.$router.push({
              name: 'RequestAccess',
              params: { carrierHasBeenClaimed: true },
            });
            return;
          }
        }
        return;
      }
      localStorage?.removeItem('identifier');
      if (this.isAMexicanCarrier) localStorage?.removeItem('identifier-mx');
      if (this.isAEuropeanCarrier) localStorage?.removeItem('identifier-eu');
      this.isLoading = false;

      await this.$store.dispatch('users/serverRefreshCurrentUser');
      // redirect to create onboarding_packet
      this.$router.push({
        name: 'OAuth Authorizations',
      });
    },
  },
};
</script>

<style></style>
